export default __webpack_public_path__ + "images/onboarding/custom-dot-c2ba3c7cf8eab26e4914b4b26413c5a6.svg";